(() => {
  'use strict';
  const WRAP = 61378047312206;
  const root = () => window.Shopify?.routes?.root || '/';
  const isWrap = item => Number(item.variant_id) === WRAP;
  const signature = item => JSON.stringify([item.variant_id, Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b)), item.selling_plan_allocation?.selling_plan?.id || null]);
  async function request(path, body) {
    const response = await fetch(root() + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {});
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error(data.description || 'No se pudo actualizar el envoltorio. Inténtalo de nuevo.');
    return data;
  }
  function parentFor(cart, wrap) {
    return cart.items.find(item => !isWrap(item) && signature(item) === wrap.properties?._mn_signature);
  }
  async function reconcile(cart, sections) {
    const updates = {};
    const counts = new Map();
    for (const wrap of cart.items.filter(isWrap)) {
      const parent = parentFor(cart, wrap);
      const used = counts.get(wrap.properties?._mn_signature) || 0;
      const qty = parent ? Math.max(0, Math.min(wrap.quantity, parent.quantity - used)) : 0;
      counts.set(wrap.properties?._mn_signature, used + qty);
      if (qty !== wrap.quantity) updates[wrap.key] = qty;
    }
    if (!Object.keys(updates).length) return cart;
    return request('cart/update.js', {updates,sections,sections_url:location.pathname});
  }
  window.MNGiftWrap = {reconcile};
  let busy = false;
  let readPromise;
  function readCart() {
    if (!readPromise) readPromise = request('cart.js').finally(() => { readPromise = null; });
    return readPromise;
  }
  function lock(value) {
    busy = value;
    document.querySelectorAll('mn-gift-wrap select, [name="checkout"], .cart__dynamic-checkout-buttons').forEach(el => {
      if ('disabled' in el) el.disabled = value;
      else el.style.pointerEvents = value ? 'none' : '';
    });
  }
  function render(cart) {
    const ids = ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer','cart-live-region-text'];
    for (const id of ids) {
      const sectionId = document.getElementById(id)?.dataset.id || id;
      const markup = cart.sections?.[sectionId];
      if (!markup) continue;
      const html = new DOMParser().parseFromString(markup,'text/html');
      if (id === 'cart-drawer') {
        const target = document.querySelector('cart-drawer');
        const source = html.querySelector('cart-drawer');
        if (target && source) { target.innerHTML = source.innerHTML; target.classList.toggle('is-empty', cart.item_count === 0); target.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => target.close()); }
      } else {
        const target = document.getElementById(id);
        const source = html.getElementById(id) || html.querySelector('.shopify-section');
        if (target && source) target.innerHTML = source.innerHTML;
      }
    }
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty',cart.item_count === 0);
  }
  class GiftWrap extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.select.addEventListener('change', event => { event.stopPropagation(); this.change(); });
      readCart().then(cart => this.sync(cart)).catch(() => {});
    }
    sync(cart) {
      const parent = cart.items.find(item => item.key === this.dataset.key);
      if (!parent) return;
      const qty = cart.items.filter(item => isWrap(item) && item.properties?._mn_signature === signature(parent)).reduce((n,item) => n + item.quantity,0);
      this.select.value = String(Math.min(qty,parent.quantity));
    }
    async change() {
      if (busy) return;
      const status = this.querySelector('[role="status"]');
      const qty = Number(this.select.value);
      lock(true);
      status.textContent = 'Actualizando…';
      try {
        let cart = await request('cart.js');
        const parent = cart.items.find(item => item.key === this.dataset.key);
        if (!parent || qty < 0 || qty > parent.quantity) throw new Error('El carrito ha cambiado. Actualiza la página y vuelve a elegir.');
        const key = signature(parent);
        const existing = cart.items.find(item => isWrap(item) && item.properties?._mn_signature === key);
        const sections = ['cart-drawer','cart-icon-bubble',document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items',document.getElementById('main-cart-footer')?.dataset.id || 'main-cart-footer','cart-live-region-text'];
        if (existing) cart = await request('cart/change.js',{id:existing.key,quantity:qty,sections,sections_url:location.pathname});
        else if (qty > 0) {
          const properties = {'Artículo':parent.product_title,'Variante':parent.variant_title || 'Única','_mn_parent':parent.key,'_mn_signature':key};
          // Preserve customisation details so the workshop can identify the exact item.
          for (const [name,value] of Object.entries(parent.properties || {})) if (!name.startsWith('_') && value) properties['Artículo · '+name] = value;
          await request('cart/add.js',{items:[{id:WRAP,quantity:qty,properties}]});
          cart = await request('cart/update.js',{updates:{},sections,sections_url:location.pathname});
        } else return;
        cart = await reconcile(cart,sections);
        render(cart);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'mn-gift-wrap',cartData:cart});
      } catch (error) {
        status.textContent = error.message;
        try { this.sync(await request('cart.js')); } catch (_) {}
      } finally { lock(false); }
    }
  }
  if (!customElements.get('mn-gift-wrap')) customElements.define('mn-gift-wrap',GiftWrap);
})();